import { Button, Input, message, Modal, Select, Space } from "antd";
import { useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function EndRideModal({
  open = false,
  onUpdated = () => {},
  onCancel = () => {},
  vehicle,
  stations = [],
  isCancel = false,
}) {
  const [reason, setReason] = useState("");
  const [selectedStation, setSelectedStation] = useState("");

  const handleEndRide = async (vehicle, isCancelled = "") => {
    let res = await apiRequest({
      path:
        apiPaths.vehicles +
        "/" +
        vehicle +
        (isCancelled ? "/cancel-ride" : "/end-ride"),
      method: "POST",
      data: { reason: isCancelled, dock_station: selectedStation },
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    onUpdated(res);
  };

  return (
    <Modal
      title={`Are you sure to ${isCancel ? "Cancel" : "End"} this Ride?`}
      centered
      //   width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <div>
        <div style={{ marginBottom: 10 }}>
          {`Note: ${
            isCancel ? "Canceling" : "Ending"
          } ride will end the ride and will ${
            isCancel ? "not detect any" : "detect"
          } ride
            cost from User wallet.`}
        </div>
        {isCancel ? (
          <>
            <div>Reason</div>
            <Input.TextArea
              onChange={(e) => {
                let txt = e.target.value;
                setReason(txt);
              }}
              style={{ height: 120 }}
              placeholder="reason here..."
            />
          </>
        ) : null}
        <div style={{ marginTop: 10 }}>Current Dock Station</div>
        <Select
          showSearch
          placeholder="Search and Select Station Number"
          optionFilterProp="children"
          onChange={(value) => {
            setSelectedStation(value);
          }}
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          options={stations.map((item) => ({
            value: item._id,
            label: item.name,
          }))}
        />
      </div>
      <Space
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
      >
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          onClick={() => {
            if (reason.length || !isCancel) {
              handleEndRide(vehicle, reason);
            }
          }}
        >
          {isCancel ? "Cancel Ride" : "End Ride"}
        </Button>
      </Space>
    </Modal>
  );
}

export default EndRideModal;
